// Tipo de ciudad
export interface Ciudad {
  Id: string;
  Nombre: string;
  CodigoDepartamento: string;
  Codigo: string;
  __type: string;
}

export const ciudadesMock : Ciudad[] = [
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "37;#Bogotá D.C.",
    "Id": "270",
    "Nombre": "Bogotá D.C."
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "38;#Amazonas",
    "Id": "271",
    "Nombre": "Leticia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "272",
    "Nombre": "Apartadó"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "273",
    "Nombre": "Barbosa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "274",
    "Nombre": "Bello"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "275",
    "Nombre": "Don Matías"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "276",
    "Nombre": "Entrerrios"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "277",
    "Nombre": "Envigado"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "278",
    "Nombre": "Girardota"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "279",
    "Nombre": "Guarne"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "280",
    "Nombre": "Itagüí"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "281",
    "Nombre": "Marinilla"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "282",
    "Nombre": "Medellín"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "283",
    "Nombre": "Puerto Berrío"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "284",
    "Nombre": "Rionegro"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "285",
    "Nombre": "Sabaneta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "286",
    "Nombre": "San Pedro"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "287",
    "Nombre": "Santa Rosa de Osos"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "39;#Antioquia",
    "Id": "288",
    "Nombre": "Yarumal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "40;#Arauca",
    "Id": "289",
    "Nombre": "Arauca"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "40;#Arauca",
    "Id": "290",
    "Nombre": "Arauquita"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "40;#Arauca",
    "Id": "291",
    "Nombre": "Fortul"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "40;#Arauca",
    "Id": "292",
    "Nombre": "Saravena"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "40;#Arauca",
    "Id": "293",
    "Nombre": "Tame"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "41;#Atlántico",
    "Id": "294",
    "Nombre": "Baranoa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "41;#Atlántico",
    "Id": "295",
    "Nombre": "Barranquilla"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "41;#Atlántico",
    "Id": "296",
    "Nombre": "Puerto Colombia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "41;#Atlántico",
    "Id": "297",
    "Nombre": "Puerto Tejada"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "41;#Atlántico",
    "Id": "298",
    "Nombre": "Sabanalarga"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "41;#Atlántico",
    "Id": "299",
    "Nombre": "Soledad"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "42;#Bolívar",
    "Id": "300",
    "Nombre": "Cartagena"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "42;#Bolívar",
    "Id": "301",
    "Nombre": "Turbaco"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "302",
    "Nombre": "Guateque"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "303",
    "Nombre": "Moniquirá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "304",
    "Nombre": "Almeida"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "305",
    "Nombre": "Chiquinquirá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "306",
    "Nombre": "Cómbita"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "307",
    "Nombre": "Duitama"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "308",
    "Nombre": "El Cocuy"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "309",
    "Nombre": "Garagoa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "310",
    "Nombre": "Miraflores"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "311",
    "Nombre": "Nobsa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "312",
    "Nombre": "Paipa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "313",
    "Nombre": "Puerto Boyacá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "314",
    "Nombre": "Ramiriquí"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "315",
    "Nombre": "Ráquira"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "316",
    "Nombre": "Samacá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "317",
    "Nombre": "Santa Rosa de Vitervo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "318",
    "Nombre": "Sativasur"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "319",
    "Nombre": "Soata"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "320",
    "Nombre": "Sogamoso"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "321",
    "Nombre": "Tunja"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "43;#Boyacá",
    "Id": "322",
    "Nombre": "Villa de Leyva"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "44;#Caldas",
    "Id": "323",
    "Nombre": "Chinchiná"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "44;#Caldas",
    "Id": "324",
    "Nombre": "La Dorada"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "44;#Caldas",
    "Id": "325",
    "Nombre": "Manizales"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "44;#Caldas",
    "Id": "326",
    "Nombre": "Riosucio"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "44;#Caldas",
    "Id": "327",
    "Nombre": "Samaná"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "44;#Caldas",
    "Id": "328",
    "Nombre": "Villamaría"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "45;#Caquetá",
    "Id": "329",
    "Nombre": "Florencia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "330",
    "Nombre": "Aguazul"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "331",
    "Nombre": "Maní"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "332",
    "Nombre": "Monterrey"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "333",
    "Nombre": "Paz de Ariporo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "334",
    "Nombre": "Tauramena"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "335",
    "Nombre": "Villanueva"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "46;#Casanare",
    "Id": "336",
    "Nombre": "Yopal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "337",
    "Nombre": "Corinto"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "338",
    "Nombre": "Miranda"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "339",
    "Nombre": "Padilla"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "340",
    "Nombre": "Patía"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "341",
    "Nombre": "Piendamó"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "342",
    "Nombre": "Popayán"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "343",
    "Nombre": "Puerto Tejada"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "344",
    "Nombre": "Rosas"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "345",
    "Nombre": "Santander de Quilichao"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "47;#Cauca",
    "Id": "346",
    "Nombre": "Villa Rica"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "48;#Cesar",
    "Id": "347",
    "Nombre": "Valledupar"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "48;#Cesar",
    "Id": "348",
    "Nombre": "Aguachica"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "49;#Chocó",
    "Id": "349",
    "Nombre": "Quibdó"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "50;#Córdoba",
    "Id": "350",
    "Nombre": "Cereté"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "50;#Córdoba",
    "Id": "351",
    "Nombre": "Montería"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "50;#Córdoba",
    "Id": "352",
    "Nombre": "Purísima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "353",
    "Nombre": "Agua de Dios"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "354",
    "Nombre": "Almeida"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "355",
    "Nombre": "Anapoima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "356",
    "Nombre": "Anolaima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "357",
    "Nombre": "Apulo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "358",
    "Nombre": "Arbeláez"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "360",
    "Nombre": "Bojacá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "361",
    "Nombre": "Cajicá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "362",
    "Nombre": "Caparrapí"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "363",
    "Nombre": "Caqueza"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "364",
    "Nombre": "Carmen de Carupa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "365",
    "Nombre": "Chaguaní"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "366",
    "Nombre": "Chía"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "367",
    "Nombre": "Chipaque"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "368",
    "Nombre": "Chocontá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "369",
    "Nombre": "Cogua"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "370",
    "Nombre": "Cota"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "371",
    "Nombre": "El Colegio"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "372",
    "Nombre": "El Rosal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "373",
    "Nombre": "Facatativá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "374",
    "Nombre": "Fomeque"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "375",
    "Nombre": "Funza"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "376",
    "Nombre": "Fusagasugá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "377",
    "Nombre": "gacheta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "378",
    "Nombre": "Girardot"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "379",
    "Nombre": "Guachetá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "380",
    "Nombre": "Guaduas"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "381",
    "Nombre": "Guatavita"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "382",
    "Nombre": "Junín"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "383",
    "Nombre": "La Calera"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "384",
    "Nombre": "La Mesa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "385",
    "Nombre": "La Palma"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "386",
    "Nombre": "La vega"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "387",
    "Nombre": "Macheta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "388",
    "Nombre": "Madrid"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "389",
    "Nombre": "Manta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "390",
    "Nombre": "Mosquera"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "391",
    "Nombre": "Nemocón"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "392",
    "Nombre": "Nilo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "393",
    "Nombre": "Nocaima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "394",
    "Nombre": "Pacho"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "395",
    "Nombre": "Puerto salgar"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "396",
    "Nombre": "Ricaurte"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "397",
    "Nombre": "San Antonio del Tequendama"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "398",
    "Nombre": "San Cayetano"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "399",
    "Nombre": "San Francisco"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "400",
    "Nombre": "San Juan de Río Seco"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "401",
    "Nombre": "Sasaima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "402",
    "Nombre": "Sesquilé"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "403",
    "Nombre": "Sibaté"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "404",
    "Nombre": "Silvania"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "405",
    "Nombre": "Soacha"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "406",
    "Nombre": "Sopó"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "407",
    "Nombre": "Suesca"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "408",
    "Nombre": "Tabio"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "409",
    "Nombre": "Tausa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "410",
    "Nombre": "Tenjo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "411",
    "Nombre": "Tibiritá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "412",
    "Nombre": "Tocaima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "413",
    "Nombre": "Tocancipá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "414",
    "Nombre": "Vergara"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "415",
    "Nombre": "Vianí"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "416",
    "Nombre": "Villa de San Diego de Ubate"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "417",
    "Nombre": "Villa de San Diego de Ubaté"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "418",
    "Nombre": "Villapinzón"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "419",
    "Nombre": "Villeta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "420",
    "Nombre": "Viotá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "421",
    "Nombre": "Zipacón"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "422",
    "Nombre": "Zipaquirá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "52;#Guainía",
    "Id": "423",
    "Nombre": "Inírida"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "53;#La Guajira",
    "Id": "424",
    "Nombre": "Maicao"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "54;#Guaviare",
    "Id": "425",
    "Nombre": "San José Del Guaviare"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "426",
    "Nombre": "Agrado"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "427",
    "Nombre": "Algeciras"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "428",
    "Nombre": "Garzón"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "429",
    "Nombre": "La Plata"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "430",
    "Nombre": "Neiva"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "431",
    "Nombre": "Pitalito"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "432",
    "Nombre": "San Agustín"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "55;#Huila",
    "Id": "433",
    "Nombre": "Tesalia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "53;#La Guajira",
    "Id": "434",
    "Nombre": "Riohacha"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "56;#Magdalena",
    "Id": "435",
    "Nombre": "Ciénaga"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "56;#Magdalena",
    "Id": "436",
    "Nombre": "Santa Marta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "437",
    "Nombre": "Puerto López"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "438",
    "Nombre": "Acacías"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "439",
    "Nombre": "Castilla La Nueva"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "440",
    "Nombre": "Cumaral"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "441",
    "Nombre": "Granada"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "442",
    "Nombre": "Guamal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "443",
    "Nombre": "Puerto Gaitán"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "444",
    "Nombre": "Restrepo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "445",
    "Nombre": "San Martín"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "57;#Meta",
    "Id": "446",
    "Nombre": "Villavicencio"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "447",
    "Nombre": "Barbacoas"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "448",
    "Nombre": "Cumbal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "449",
    "Nombre": "El Charco"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "450",
    "Nombre": "El Tambo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "451",
    "Nombre": "Ipiales"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "452",
    "Nombre": "La Cruz"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "453",
    "Nombre": "La Unión"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "454",
    "Nombre": "Olaya Herrera"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "455",
    "Nombre": "Pasto"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "456",
    "Nombre": "Ricaurte"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "457",
    "Nombre": "Samaniego"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "458",
    "Nombre": "San Pablo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "459",
    "Nombre": "Sandoná"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "460",
    "Nombre": "Taminango"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "461",
    "Nombre": "Tumaco"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "58;#Nariño",
    "Id": "462",
    "Nombre": "Túquerres"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "59;#Norte de Santander",
    "Id": "463",
    "Nombre": "Cúcuta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "59;#Norte de Santander",
    "Id": "464",
    "Nombre": "Ocaña"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "59;#Norte de Santander",
    "Id": "465",
    "Nombre": "Pamplona"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "60;#Putumayo",
    "Id": "466",
    "Nombre": "Mocoa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "61;#Quindío",
    "Id": "467",
    "Nombre": "Armenia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "61;#Quindío",
    "Id": "468",
    "Nombre": "La tebaida"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "62;#Risaralda",
    "Id": "469",
    "Nombre": "Belén de umbría"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "62;#Risaralda",
    "Id": "470",
    "Nombre": "Dosquebradas"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "62;#Risaralda",
    "Id": "471",
    "Nombre": "La virginia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "62;#Risaralda",
    "Id": "472",
    "Nombre": "Pereira"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "473",
    "Nombre": "Barbosa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "474",
    "Nombre": "Barrancabermeja"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "475",
    "Nombre": "Bucaramanga"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "476",
    "Nombre": "Cimitarra"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "477",
    "Nombre": "Florián"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "478",
    "Nombre": "Floridablanca"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "479",
    "Nombre": "Girón"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "480",
    "Nombre": "Güepsa"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "481",
    "Nombre": "Málaga"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "482",
    "Nombre": "Piedecuesta"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "483",
    "Nombre": "Puente Nacional"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "484",
    "Nombre": "San gil"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "485",
    "Nombre": "Santander de Quilichao"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "486",
    "Nombre": "Socorro"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "63;#Santander",
    "Id": "487",
    "Nombre": "Suaita"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "51;#Cundinamarca",
    "Id": "488",
    "Nombre": "Subachoque"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "64;#Sucre",
    "Id": "489",
    "Nombre": "Sampués"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "64;#Sucre",
    "Id": "490",
    "Nombre": "Sincelejo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "491",
    "Nombre": "Carmen de Apicalá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "492",
    "Nombre": "Chaparral"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "493",
    "Nombre": "Espinal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "494",
    "Nombre": "Girardot"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "495",
    "Nombre": "Guamo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "496",
    "Nombre": "Honda"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "497",
    "Nombre": "Ibagué"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "498",
    "Nombre": "Lérida"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "499",
    "Nombre": "Líbano"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "500",
    "Nombre": "Mariquita"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "501",
    "Nombre": "Melgar"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "502",
    "Nombre": "Natagaima"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "503",
    "Nombre": "Purificación"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "65;#Tolima",
    "Id": "504",
    "Nombre": "San Antonio"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "505",
    "Nombre": "Cali"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "506",
    "Nombre": "Buenaventura"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "507",
    "Nombre": "Cartago"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "508",
    "Nombre": "Dagua"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "509",
    "Nombre": "Florida"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "510",
    "Nombre": "Ginebra"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "511",
    "Nombre": "Guadalajara de Buga"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "512",
    "Nombre": "Jamundí"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "513",
    "Nombre": "La Unión"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "514",
    "Nombre": "La Victoria"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "515",
    "Nombre": "Palmira"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "516",
    "Nombre": "Roldanillo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "517",
    "Nombre": "Sevilla"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "518",
    "Nombre": "Tuluá"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "519",
    "Nombre": "Yumbo"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "520",
    "Nombre": "Zarzal"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "66;#Valle del Cauca",
    "Id": "521",
    "Nombre": "Caicedonia"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "67;#Vaupés",
    "Id": "522",
    "Nombre": "Mitú"
  },
  {
    "__type": "Ciudades:#Consorcio.Proveedores.Entities.Services.Proveedores.Request",
    "Codigo": "0",
    "CodigoDepartamento": "68;#Vichada",
    "Id": "523",
    "Nombre": "Cumaribo"
  }
];